import React, { useState } from 'react'; // Import React and useState hook
import PatientContext from './patientContext'; // Import the PatientContext

// PatientProvider component
const PatientProvider = ({ children }) => {
    // State variable to manage the selected patient
    const [selectedPatient, setSelectedPatient] = useState('');

    return (
        // Provide the selected patient and setSelectedPatient function to children components
        <PatientContext.Provider value={{ selectedPatient, setSelectedPatient }}>
            {children} {/* Render children components within the context provider */}
        </PatientContext.Provider>
    );
}

// Export the PatientProvider component
export default PatientProvider;
